export const ManageFunds = 'Funds.Manage'
export const EditInvestorPreferences = 'InvestorPreferences.Edit'

export const RoleCFN = 'Role.CFN'
export const RoleManager = 'Role.Manager'
export const RoleAllocator = 'Role.Allocator'
export const RoleServiceProvider = 'Role.ServiceProvider'
